import Vue from 'vue'
import Vuex from 'vuex'

import App from './App'
import Router from './router'
import Store from './store'
import i18n from './plugins/i18n'

import VueTextareaAutosize from 'vue-textarea-autosize'
import vSelect from 'vue-select'
import Ziggeo from 'vue-ziggeo'
import VTooltip from 'v-tooltip'
import Meta from 'vue-meta'

// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// global components
import Creating from '@/components/Parts/Creating'
import ValidateMessage from '@/components/Parts/ValidateMessage'
import NoResults from '@/components/Parts/NoResults'
import TextareaEditable from '@/components/Fields/TextareaEditableTinymce'
import Modalo from '@/components/Modalo/Modalo'
// Directives
import Directives from './directives'
// Filters
import Filters from './filters'
// Http
import Http from './utils/Http'
// Helpers
import Helpers from './utils/Helpers'
// vue-slider-component
import 'vue-slider-component/theme/default.css'
// vue-intercom
import VueIntercom from 'vue-intercom'

// VueParticles
import VueParticles from 'vue-particles'

// Highcharts (Global Add module)
import Highcharts from 'highcharts'
import NoData from 'highcharts/modules/no-data-to-display'
NoData(Highcharts)

// VueIntercom
Vue.use(VueIntercom, { appId: 'lnys0n51' })

// TextareaAutosize
Vue.use(VueTextareaAutosize)

Vue.use(Vuex) // Vuex
Vue.use(Ziggeo) // ziggeo
Vue.use(VTooltip) // VTooltip
Vue.use(Meta) // Meta

// Directives, Filters, Http, Helpers
Directives(Vue)
Filters(Vue)
Http(Vue)
Helpers(Vue)

// VueParticles
Vue.use(VueParticles)

// Import component
Vue.use(Loading, {
  color: '#3bf',
  loader: 'dots',
  opacity: 0.5
}, {
  // slots
})

// global components
Vue.component('v-select', vSelect)
Vue.component('Creating', Creating)
Vue.component('ValidateMessage', ValidateMessage)
Vue.component('NoResults', NoResults)
Vue.component('TextareaEditable', TextareaEditable)
Vue.component('Modalo', Modalo)

// import assets
require('./assets/css/style.css')

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^vapi-/]

// defaults
Vue.prototype.$default = {
  limit: 30
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router,
  i18n: i18n,
  store: Store,
  render: h => h(App)
})

// ngrok http 9005 --url=https://quickin-app.ngrok-free.app --host-header=rewrite



// WEBPACK FOOTER //
// ./src/main.js